export enum LogType {
  Project = 'Project',
  Service = 'Service'
}